<!--
	UNVERIFIED VISUALS — the Figma connector was unavailable when this was built, so both visual
	values below are reasoned assumptions and still need confirming against the design:
	- `ds-text--small` (12px / 16px) — the removed `.ds-header__button` in this same band was 12px,
	  and the sibling `ds-subheader` page title is 12px.
	- `ds-h-colors-txt--white` (`--eff-white-0`) — the band's own inherited text colour, and this is
	  its primary label rather than a dimmed one. The dimmed alternative is `ds-h-colors-txt--white-7`.
-->
<!--
	Truthiness guard rather than `title() !== null`: an empty string would otherwise render an empty
	element carrying a tooltip bound to nothing. The alias reads the signal once and is non-nullable,
	which is what `[matTooltip]` needs.
-->
@if (title(); as headerTitle) {
	<span
		showTooltipIfTruncated
		class="slds-truncate ds-text--small ds-h-colors-txt--white ds-header-title__text"
		[matTooltip]="headerTitle"
		>{{ headerTitle }}</span
	>
}
